// extracted by mini-css-extract-plugin
module.exports = {"info-head":"NoticeHeader_info-head__1ZXr2","info-title":"NoticeHeader_info-title__2qGcd"};